import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { getTipoElencoPorId } from 'services/servicioGet';
import { TipoElenco } from 'utils/models/types';

interface TipoElencoState {
  tipoElenco: TipoElenco;
  loadingTipoElenco: boolean;
  errorTipoElenco: string | null;
}

// Estado inicial del slice
const initialState: TipoElencoState = {
  tipoElenco: {
    MontoFijoSala: 0,
    PorcentajeGananciaTeatro: 0,
    Id: 0,
    Nombre: '',
  },
  loadingTipoElenco: false,
  errorTipoElenco: null,
};

// Thunk para obtener el tipo de elenco
export const fetchTipoElenco = createAsyncThunk<TipoElenco, void, { rejectValue: string }>(
  'fetchTipoElenco',
  async (_, { rejectWithValue }) => {
    try {
      const response = await getTipoElencoPorId();
      return response;
    } catch (error: unknown) {
      return rejectWithValue(error instanceof Error ? error.message : String(error));
    }
  }
);

// Slice de tipos de elenco
const tipoElencoSlice = createSlice({
  name: 'tipoElenco',
  initialState,
  reducers: {},
  extraReducers: builder => {
    builder
      .addCase(fetchTipoElenco.pending, state => {
        state.loadingTipoElenco = true;
        state.errorTipoElenco = null;
      })
      .addCase(fetchTipoElenco.fulfilled, (state, action) => {
        state.tipoElenco = action.payload;
        state.loadingTipoElenco = false;
      })
      .addCase(fetchTipoElenco.rejected, (state, action) => {
        state.loadingTipoElenco = false;
        state.errorTipoElenco = action.payload as string;
      });
  },
});

export default tipoElencoSlice.reducer;
